<div class="flex flex-col gap-6">
  <div>
    <div class="flex gap-2 font-bold">
      <span class="uppercase">Pure Beauty Media</span>
      <span>Sp. z o.o.</span>
    </div>

    <div>Al. Jerozolimskie 85 lokal 21</div>
    <div>02-001 Warszawa</div>
    <div>
      <app-footer-link
        link="mailto:kontakt@purebeauty.pl"
        text="kontakt@purebeauty.pl" />
    </div>
  </div>

  <div>
    <div class="font-bold uppercase">Adres do wysyłki:</div>
    <div class="flex gap-2">
      <span>Magazyn Pure Beauty</span>
    </div>
    <div>ul. Sochaczewska 21a</div>
    <div>96-515 Paprotnia</div>
  </div>

  <div>
    <div>KRS 0000859715</div>
    <div>REGON 387048691</div>
    <div>NIP 9512507422</div>
  </div>

  <app-footer-social-links />
</div>
